// Angular Imports
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

// lodash imports

// Store
import { BillingPaymentPaths } from '@amfam/shared/models';
// My Account Imports
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel, DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'ds-bill-account-contact-confirmation',
  templateUrl: './bill-account-contact-confirmation.component.html',
  styleUrls: ['./bill-account-contact-confirmation.component.scss'],
  standalone: false
})
export class BillAccountContactConfirmationComponent implements OnInit {
  public confirmationData: Observable<ConfirmationModel>;
  customerCareNumber: string;
  constructor(
    private dockingService: DockingBarService,
    private pageTitle: PageTitleService,
    private copyService: CopyService,
    private store: Store<fromRoot.RootState>
  ) {}

  ngOnInit() {
    // Fetch the copy
    const pageTitle: string = this.copyService.getCopy('billing.contactPageTitle');
    this.store
      .select(BrandSelectors.selectCusCareNumber)
      .pipe(take(1))
      .subscribe(number => (this.customerCareNumber = number));

    // Set the page title and docking bar
    this.pageTitle.set(pageTitle);
    this.dockingService.registerHeading(pageTitle);
    this.confirmationData = this.formatConfirmationData();
  }

  private formatConfirmationData(): Observable<{ confirmation: any }> {
    return of({
      confirmation: {
        heading: this.copyService.getCopy('billing.contactBillingConfirmationSucess'),
        subHeading: this.copyService.getCopy('billing.contactBillingConfirmationSucessText', {
          customerCareNumber: this.customerCareNumber
        }),
        status: 'success'
      }
    });
  }

  public backToBilling() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: [BillingPaymentPaths.BILLING_SECTION_PAGE]
      })
    );
  }
}
